import React, { useEffect, useState,useRef, useContext,useMemo } from "react";
import "../components/css/newsletter.css";
import { useNavigate } from "react-router-dom";
import searchIcon from "../images/search-26233.png";
import tekst from "../images/Tekst_img.png";
import picture from "../images/Picture_img.png";
import movie from "../images/Film_img.png";
import movie2 from "../images/film_img1.png";
import trailer from "../images/Trailer_img.png"
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import upload from '../images/upload_on_cloud.png'
import deleteIcon  from  '../images/delete.png'
import { keyContext } from "../components/KeyContext";
import moment from "moment";
import TextEditor from "./PlainTextEditor";

function NewsletterEditing({chosenTemplate,orgID,setChosenTemplate,saveBtnShown,newsletterNo,sideDiv}) {
  const { openSideDiv, setOpenSideDiv,setEditDiv,editDiv,contentEdit, setContentEdit} = useContext(keyContext)
  const [placeholderID, setPlaceholderID] = useState();
   const [text, setText] = useState("");
     const [isOpen, setIsOpen] = useState(false);
  const [newsletterError, setNewsletterError] = useState();
  const key = sessionStorage.getItem("key");
   const [sortID, setSortID] = useState(0)
     const [sortedBy, setSortedBy] = useState('Nyeste først');
  const [chosenInhold, setChosenInhold] = useState();
  const [contentKey, setContentKey] = useState();
  const [editText, setEditText] = useState('');
  const [files, setFiles] = React.useState([]);
  const [chosenFile, setChosenFile] = useState('VÆLG FIL')
  const [filmSearch, setFilmSearch ]  = useState([])
  const [filterParam, setFilterParam] = useState(["name"]);
  const [searchParam] = useState(["name"]);
  const [q, setQ] = useState("");
  const [movies, setMovies] = useState([{}]);
  const [chosenMovieNo, setChosenMovieNo] = useState();
  const [chosenImgIndex, setChosenImgIndex] = useState();
  const [chosenImgFile, setChosenImgFile] = useState();
  const [templateItems, setTemplateItems] = useState([{}]);
  const [imgPath, setImgPath] = useState();
  const [imgLink, setImgLink] = useState();
  const [previewUrl, setPreviewUrl] = useState();
  const [contentDlt, setContentDlt] = useState();
  const [contentInsert, setContentInsert] = useState();
  const [saved, setSaved] = useState();
  const [loadedImgs, setLoadedImgs] = useState([{}]);
  const [imgUpload, setImgUpload] = useState(false);
  const [imgLinkText, setImgLinkText] = useState();
 
 let ge = sessionStorage.getItem('newsletter_bio')
   let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]

  // call for newslatter template items get
 useEffect(() => {
    if(key && (orgID || news_orgs)) { 

    const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_templateitems_get?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}`;
     fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then(result => {
         setTemplateItems(result)
    
      })
       }
  }, [key,orgID]);

  useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${news_orgs?news_orgs:orgID}`;
     if(key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
           
      })
      .then(result => setMovies(result.Movies))
    }
  }, [orgID]);

  function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }

   function search(items) {
    
      return items && items.filter((item) => {
       
          if (filterParam == "name") {
              return searchParam.some((newItem) => {
                  return (
                    item[newItem] && item[newItem]
                          .toString()
                          .toLowerCase()
                          .indexOf(q.toLowerCase()) > -1
                  );
              });
          }
      });
     
     }
   
   //------ api call for movie search ------------
     useEffect(() => {
      const endpoint1 = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${'%25'+q+'%25'}`;
     
        if(key && q ) {
   
          fetch( endpoint1, {
            method: "GET",
            headers: {
              ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            },
          })
          .then(res =>  { 
        
            if(res.status === 200) {
              return  res.json() 
            }              
          })
          .then(result => { 
                  if(result) { 
                      // q.length && 
                       setFilmSearch(result)
                  }       
          })
         
        }
     },[key,q])
function decodeBase64(str) {
  return atob(str);
}

function encodeBase64(str){ 
    return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));  
}
 
 
  function handleContentInsert () {
 
    const data = chosenInhold === 1  ? { 
      "NewsletterNo" : newsletterNo,
      "html":text
    }
    : chosenInhold === 2 ? {
      "NewsletterNo" : newsletterNo,
      "ImagePath" : `https://admin.ebillet.dk/images/newsletter/${news_orgs?news_orgs:orgID}/${chosenImgFile}`,
      "Link":imgLinkText
    } 
    : {
      "NewsletterNo" : newsletterNo,
      "WebMovieNo":chosenMovieNo
    }
 
 
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_content_insert?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&placeholder=${placeholderID}&TemplateItemNo=${contentKey}&jsonDataBase64=${encodeURIComponent(encodeBase64(JSON.stringify(data)))} `;
    fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
        setChosenTemplate(result.NewBody)
        setChosenInhold()
        setContentKey()
         setOpenSideDiv(false)
         setSaved((current => !current))
        // setEditDiv(false)
        setContentInsert(true)
        setChosenImgIndex()
        setText()
      })
  } 
  const data = filmSearch.length ?  filmSearch : movies && toFindDuplicates(movies)
  Object.values(filmSearch  ? filmSearch :  toFindDuplicates(movies) )


  function cancelTekstEdit () {
    setContentKey()
    setContentEdit(false)
    setChosenInhold()
    setChosenImgIndex()
    setText()
  }
    const onDragOver = (ev) => ev.preventDefault();
    const onDropHandler = (ev) => {
            ev.preventDefault();
        
            let file = "";
            if (ev.dataTransfer.items) {
              // Use DataTransferItemList interface to access the file(s)
              file =
                [...ev.dataTransfer.items]
                  .find((item: any) => item.kind === "file")
                  .getAsFile() ;
            } else {
              // Use DataTransfer interface to access the file(s) 
              file = ev.dataTransfer.files[0];
            }
            setFiles([...files, file]);
          };


      function addContent(button) {   }
  
 useEffect(() => {
   
   const handleClick = (e) => {
    
         setPlaceholderID(e.target.offsetParent.id)
          // setContentEdit((current => !current))
           setOpenSideDiv(true);
           if(saveBtnShown === false ) {
              // setOpenSideDiv((current) => !current);
          }
           else {
             setNewsletterError('nyhedsbrev ikke gemt!')
           }
        };
    const contentAreas = document.querySelectorAll('.content-area')
  
    contentAreas.forEach(area => {
      
      area.style.height='20px'
       const button = area.querySelector('.add-button');
       area.addEventListener('mousemove', (e) => {
                   
                    const rect = area.getBoundingClientRect();
                    const x = e.clientX - rect.left - 20; // Subtract half the button width (40px / 2 = 20px)
                
                    button.style.left = x < 430 ? x + 'px' : '430px';
                    
                addContent(button)
                });
                  button.addEventListener('click',handleClick)
               addContent()
          })
    },[saveBtnShown,contentDlt,contentInsert,saved,setOpenSideDiv] );

  

 function handleContentDlt (e) {
  
  const plc = e.target.offsetParent.id

    const endpoint =  `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_content_delete?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&NewsletterNo=${newsletterNo}&content_placeholder=${plc} `
   fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
         setChosenTemplate(result.NewBody)
         setContentDlt(true)
         setSaved((current => !current))
      })
  }

    useEffect(() => {
       
      const contentItems = document.querySelectorAll('.content_item')  
         let close_btn = document.createElement('button')
              close_btn.innerHTML='X' 
              close_btn.className='close'
              close_btn.style.position='absolute'
              close_btn.style.top=0
              close_btn.style.right=0     
      contentItems.forEach(item => {
     
     
        item.addEventListener('mousemove', (e) => {
         
          item.style.border='1px solid red'
          item.style.position='relative'
          if(!item.querySelector('.close-btn')) {
              item.appendChild(close_btn)          
           }
               
            })
              item.addEventListener('mouseout', (e) => {
              item.style.border='none'
              item.removeChild(close_btn)
         })
      }) // for each endin
         close_btn.addEventListener('click', handleContentDlt)
       

    }, [chosenTemplate,editDiv]);

async function imageToDataURI(url) {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;

    reader.readAsDataURL(blob);
  });
}

// fetching images from server
useEffect(() => {
   const endpoint =  `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_image_list?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID} `
fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
       
        setLoadedImgs(result)
         setImgUpload(false)
      })
}, [imgUpload,key,news_orgs,orgID]);

 async function handleUpload  (e)  {
  
    setChosenFile(e.target.files[0].name)
   
    const file = e.target.files[0];
    const file_name = e.target.files[0].name
    if (!file) return;

   const imageUrl = URL.createObjectURL(file); // e.g. "blob:http://localhost:3000/abc-123"
    setPreviewUrl(imageUrl);
   

   const image_base = await imageToDataURI(imageUrl);


  
     const endpoint =  `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_image_save`
     fetch(endpoint, {
        method: "POST",
        headers: {
          'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          'Content-Type':  'application/x-www-form-urlencoded',   
        },
       body:`Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&FileNameBase64=${encodeBase64(file_name)}&ImageBase64=${encodeURIComponent(image_base)}`
     
     })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
       setImgUpload(true)
      
        setChosenFile('VÆLG fIL')
      })
 
 
  }

    const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`

 
      let sorting = [
        {
            id: 0,
            name: 'Nyeste først'
        },
        {
            id: 1,
            name: 'alphabetisk'
        },
       
    ]
function handleSort (item) {
  setSortID(item.id)
  setIsOpen(false)
    setSortedBy(item.name)
}
  
  function handleImgList (item,index) {
    setChosenImgIndex(index)
    setChosenImgFile(atob(item.FileNameBase64))
  }



  function handleImgDelete (item) {
  
    let fileNameBase = item.FileNameBase64
    
     const endpoint =  `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_image_delete?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&FileNameBase64=${fileNameBase} `
       fetch(endpoint, {
           method: "GET",
           headers: {
                 ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                  },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
          
           setImgUpload(true)
      })
  }
    function handleArrrow() {
        setIsOpen((current) => !current);
    }

  return (
     <section style={{display: saveBtnShown === false || sideDiv === true  ? 'grid' : '',gridTemplateColumns:openSideDiv === true ? '1fr 1fr':'',paddingLeft:sideDiv == 'undefined' ?'55px':'',padding:'30px 0px'}}>

         <main  >
          {chosenTemplate ?   
             <div  dangerouslySetInnerHTML={{ __html: chosenTemplate }}></div>
             : null}
         </main>
    
        {openSideDiv === true ? (
          <div>
            <aside className="asideContainer" style={{marginRight:'1px',width:'550px'}}>
              { (chosenInhold === 1  ) ?
              <section style={{position:'relative'}}>
                  {/* <div style={{backgroundColor:'white',width:'500px',margin:'20px 27px',height:'398px',border:'1px solid #ccc'}}>
                       <ReactQuill theme="snow" value={editText} onChange={setEditText} />
                                
                  </div> */}
                     {/*SIMPLE TEXT EDITOR WITHOUT HTML TAGS* */}
                     <div> <TextEditor value={text} onChange={setText}  /></div>
                     
                    <div style={{position:'absolute',bottom:'-48px',right:'27px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               
               : (chosenInhold === 2) ?
               <section>
     
                <div className="chooseContentFilm" style={{margin:'23px 30px 10px 36px'}}>
                  <p className="content_title">Indsæt billede</p>
                  <div className="chooseFileContainer" id="drop_zone" onDrop={onDropHandler} onDragOver={onDragOver} >
                    <div style={{display:'flex'}} >
                     <label for="file-upload" class="custom-file-upload">  {chosenFile}</label>
                  
                     <input id="file-upload" type="file" onChange={(e) => handleUpload(e)}/>
                     <div className="uploadImgDiv" style={{}}><img src={upload} alt="upload" /></div>
                 
                   </div>
                     {/* { <img style={{width:'100%',zIndex:1,position:'relative'}} src={previewUrl} alt='preview'/> } */}

                   <p className="drop-here-text">eller træk fil til dette felt</p>
                    <div style={{fontSize:'12px',marginTop:'-25px',color:'green'}}>{files[0] && files[0].name}</div>
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',marginTop:'50px',marginRight:'16px'}}>
                    <p className="img_arkiv">Billedearkiv</p>
              
                    <div className='sorting' style={{width:'179px', border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",borderRadius:'4px',position:'relative'
                   
                   }}>
                              
                                <div className=''>
                                    <div className='sortingContainer' style={{
                                      //  borderBottomLeftRadius: isOpen ? '0px' : '8px',
                                        borderTopLeftRadius: '8px',
                                        borderTopRightRadius: '8px',height: '40px'
                                       // borderBottomRightRadius: isOpen ? '0px' : '8px', boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.15)'
                                    }} >
                                        <div style={{
                                          //  padding: "5px 8px",
                                            boxSizing: "border-box",
                                            height: "40px",  boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.15)'
                                        }}>
                                            <p style={{padding:'10px',lineHeight:'20px' }}>{sortedBy}</p>
                                            <span className="select-line" style={{ backgroundColor: "#8d8d8d", position:'absolute',right:'30px',top:'0px'}}></span>

                                            <button   onClick={() => handleArrrow()} style={{position:'absolute',right:'7px',top:'6px'}}>  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none"> <path d="M0.5 0.5L7 7L13.5 0.5" stroke="#46484C" stroke-linecap="round"/></svg></button>
                                           
                                        </div>

                                    {isOpen && 
                                            <div className="sortingDiv" style={{borderRight:'1px solid #8d8d8d',borderLeft:'1px solid #8d8d8d',height:'70px',zIndex:177771,backgroundColor:'white',borderRadius:'4px',position:'absolute',width:'179px',left:'-1px',top:'41px',borderRight:'1px solid #8d8d8d',borderBottom:'1px solid #8d8d8d'}}>
                                                {sorting && sorting.map((item) => (
                                                    <p key={item.id} id={item.id} style={{
                                                        height: '25px', fontSize: '16px', 
                                                        letterSpacing: '0.54px',padding:'8px'
                                                    }} /*onChange={() => setSortID(item.id)}*/ onClick={() => handleSort(item)}>{item.name}</p>
                                                ))}

                                            </div>
}
                                        
                                    </div>

                               </div>
                           </div>
                  </div>
                  <div className="ImgContainer" style={{marginTop:'16px',borderTop:'1px solid #f7f7f7'}}>

                 
                {loadedImgs && loadedImgs.sort((a,b) => sortID === 1 ? decodeBase64(a.FileNameBase64).localeCompare( decodeBase64(b.FileNameBase64),undefined,{ sensitivity: 'base' }) 
                : sortID === 0 ?  moment(a.FileCreated).format('YYYY-MM-DD') < moment(b.FileCreated).format('YYYY-MM-DD') ? 1 : -1  : null)          
                .map((item,index) => (
                 
                  <div style={{position:'relative'}}>
                     <div className="image_arkiv_div" onClick={() =>handleImgList(item,index)} style={{border:chosenImgIndex === index ?'1px solid red' : '',}}>
                      <img  src={`data:image/jpeg;base64,${item.ThumbnailBase64}`} alt='img'  />
                      <div style={{marginTop:chosenImgIndex === index ?'':'10px'}}> 
                        <p className="text_elip" style={{width:'280px',marginTop:'10px',fontSize:'12px',fontWeight:700,letterSpacing:'0.24px',color:'#101010'}}>{decodeBase64(item.FileNameBase64)}</p>
                        <p  style={{margin:0,fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',color:'#46484c'}}>Uploadet  {moment(item.FileCreated).format('DD/MM/YYYY')}</p></div>
                    </div>
                    <button style={{position:'absolute',top:'30%',right:'38px'}} onClick={() => handleImgDelete(item)} > 
                      <img src={deleteIcon}alt="" />
                     </button>
                    {chosenImgIndex === index ?<label style={{position:'absolute',top:'65%',left:'20%'}}> Link: <input type='text' onChange={(e) => setImgLinkText(e.target.value)} /> </label> : null}
                    </div>
                    ))}
                
                  </div>

                </div>
                  <div style={{float:'right',marginRight:'32px',marginBottom:'10px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM3</button>
                    </div> 
               </section>
               : (chosenInhold === 3  ) ?
               <section >
                <div className="chooseContentFilm">
                  <p className="content_title">Vælg film</p>
                   <div style={{ position: "relative",width:'402px' }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter film" value={q}   
                    onChange={(e) => setQ(e.target.value)}
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div className="filmImgContainer" style={{}}>
                  
                     {  (orgID || news_orgs) && search(data) && search(data).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div style={{position:'relative',border:chosenMovieNo === movie.No ? '2px solid red' : ''}}>
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name}  alt={movie.name} width='125px' height='185px' />  
                 <button className="filmImgChoose" onClick={() => setChosenMovieNo(movie.No)}>Vælg</button>                       
                    </div>
                    ))}    

                   
                </div>
                </div>
                  <div style={{float:'right',marginRight:'32px',marginBottom:'10px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               : (contentKey === 'd' && contentEdit === true ) ?
                <section className="chooseContentFilm">
                  <p className="content_title">Vælg trailer</p>
                   <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter trailer"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                 <div style={{position:'relative',top:'55px',float:'right',bottom:'10px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM5</button>
                    </div> 
               </section>
              :

            <>  
              <div className="allContentContainer">
                <p className="content_title">Vælg inholdstype</p>
                <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter indholdstype"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div style={{  display: "flex", gap: "18px",  flexWrap: "wrap",  marginTop: "80px",  }} >
                  {templateItems.map((template) => {
                    return    <div
                    className="content_img_container" onClick={() => {setContentKey(template.No); setChosenInhold(template.ItemTypeNo)}}
                    style={{ paddingTop:template.ItemTypeNo === 3 ?  '15px' : template.ItemTypeNo === 2 ? '40px': "31px", border: contentKey === template.No ? '1px solid #982f2f'  : ''}}
                  >
                    <img src={template.ItemTypeNo === 2 ? picture : template.ItemTypeNo === 3 ? movie:  tekst} alt="" />
                    {template.ItemTypeNo === 3 ? <img src={movie2} alt='movie' /> : null }
                    <div
                      style={{
                        position: "absolute",
                        bottom: "15px",
                        width: "100%",
                        height: "22px",
                        lineHeight:'15px'
                      }}
                    >
                      <p className="img_title" style={{color: contentKey === template.No ? '#982f2f' : '',fontWeight: contentKey === 'a' ? 700 : 400}}>{template.Name}</p>
                    </div>
                  </div>
                  })}
               
           
                </div>
              </div>

            
</>
 }
            </aside>
          </div>
        ) 
        : null
        }


          
       </section>
  )
}

export default NewsletterEditing